// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MyProfile.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------


  import React, { Component } from 'react';
  import PropTypes from 'prop-types';
  import connect from 'share/enhancers/Izenda.Connect';
  import uiState from 'logic/Izenda.UiState';
  import Config from 'Izenda.Config';
  import Sidebar from 'share/components/layout/Izenda.Sidebar';
  import MainContent from 'share/components/layout/Izenda.MainContent';
  import MainWrapper from 'share/components/layout/Izenda.MainWrapper';
  import MyPreference from './MyPreference/Izenda.MyPreference';
  import SecurityOptions from './SecurityOptions/Izenda.SecurityOptions';
  import ExportManager from './ExportManager/Izenda.ExportManager';
  import SettingsLevel from 'modules/Settings/SettingsLevel/Izenda.SettingsLevel';
  import SettingsStore from 'logic/Izenda.SettingsStore';
  import ContextMenu from 'share/components/layout/Izenda.ContextMenu';
  import MyProfileConstants from 'logic/data/Izenda.MyProfileConstants';
  import { placeholder, filter } from 'lodash/fp';

  const viewComponents = {
    myPreference: {
      component: MyPreference
    },
    securityOptions: {
      component: SecurityOptions
    },
    exportManager: {
      component: ExportManager
    },
    notFound: {
      component: require('share/components/controls/Izenda.NotFound')
    }
  };

  function getComponentInfo(key) {
    return placeholder(viewComponents).get(key, viewComponents.notFound);
  }

  @connect()
  class MyProfile extends Component {

    static propTypes = {
      store: PropTypes.object.isRequired
    };

    settingStore: SettingsStore;

    constructor(props: any) {
      super(props);
      this.settingStore = new SettingsStore(true);
      uiState.currentUser.systemAdmin && uiState.setDisableSettingLevel(true);
    }


    componentWillUnmount() {
      uiState.enableSystemSetting();
      this.settingStore.destroy();
    }

    render() {
      const model = this.props.store.contextMenu;

      if (uiState.currentUser.isUserProfileHidden) {
        const exportManagerKey = MyProfileConstants.MENU_DEFINITION[2].key;
        model.contextMenu = filter(item => item.key === exportManagerKey, model.contextMenu);
        model.changeActiveLink && model.changeActiveLink(exportManagerKey);
      } else if (Config.Integration) {
        const securityOptionsKey = MyProfileConstants.MENU_DEFINITION[1].key;
        model.contextMenu = filter(item => item.key !== securityOptionsKey, model.contextMenu);
      }

      const renderChangedIcon = function(item) {
        return item.isDirty ? <span className='icon-attention warning-color' title='Data source changes' /> : '';
      };

      return (
        <section className='izenda-Wrapper'>
          <SettingsLevel store={this.settingStore} />
          <MainWrapper settingStore={this.settingStore}>
            <div className='izenda-TableLayout u_paddingTopBottom'>
              <Sidebar>
                <ContextMenu
                  dataSource={model.contextMenu}
                  activeKey={model.contextMenuActiveLink}
                  enabled
                  onSelected={this.changeActiveKey}
                  renderChangedIcon={renderChangedIcon}
                />
              </Sidebar>

              <MainContent>{this.renderContent()}</MainContent>
            </div>
          </MainWrapper>
        </section>
      );
    }

    renderContent = () => {
      const { store } = this.props;
      const info = getComponentInfo(store.contextMenu.contextMenuActiveLink);
      return <info.component store={store} />;
    };

    changeActiveKey = (newLink: any): void => {
      const {
        props,
        props : { store : { contextMenu } }
      } = this;

      if (contextMenu.contextMenuActiveLink !== newLink) {
        props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function() {
          contextMenu.changeActiveLink(newLink);
        });
      }
    }
  }

  export default MyProfile;




// WEBPACK FOOTER //
// ./ui/modules/MyProfile/Izenda.MyProfile.js